import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
const testimonials = [{
  name: 'Sarah Jenkins',
  style: 'Knotless Braids',
  text: "Absolutely the best braiding experience I've ever had. The salon is beautiful, the staff is professional, and my edges are intact! The tension was perfect."
}, {
  name: 'Michelle O.',
  style: 'Goddess Locs',
  text: 'I felt like royalty from the moment I walked in. They really take their time to ensure every single loc is perfect. I get compliments daily.'
}, {
  name: 'Aisha T.',
  style: 'Stitch Braids',
  text: "Clean parts, neat braiding, and such a welcoming atmosphere. It's so hard to find a salon that values your time, but they started exactly at my appointment time."
}];
export function TestimonialsSection() {
  return <section id="testimonials" className="py-8 md:py-24 bg-white relative overflow-hidden" data-id="element-380">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-381">
        <div className="text-center mb-10 md:mb-16" data-id="element-382">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-heading font-bold text-jet mb-4" data-id="element-383">
            What Our Clients Are Saying
          </motion.h2>
          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} className="h-1 w-24 bg-burgundy mx-auto rounded-full mb-6" data-id="element-384"></motion.div>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-jet/70 text-lg max-w-2xl mx-auto" data-id="element-385">
            Real reviews from real clients who trust us with their crown
          </motion.p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-386">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-white border border-gray-200 p-8 rounded-2xl relative group hover:shadow-lg transition-shadow duration-300" data-id="element-387">
              <QuoteIcon className="absolute top-6 right-6 w-12 h-12 text-burgundy/10 group-hover:text-burgundy/20 transition-colors" data-id="element-388" />
              <div className="flex gap-1 mb-6" data-id="element-389">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-burgundy text-burgundy" data-id="element-390" />)}
              </div>
              <p className="text-jet/70 text-lg leading-relaxed mb-8 font-light italic" data-id="element-391">
                "{testimonial.text}"
              </p>
              <div className="flex items-center gap-4 border-t border-gray-100 pt-4" data-id="element-392">
                <div className="w-12 h-12 bg-burgundy/10 rounded-full flex items-center justify-center text-burgundy font-heading font-bold text-xl" data-id="element-393">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-394">
                  <h4 className="text-jet font-bold" data-id="element-395">{testimonial.name}</h4>
                  <p className="text-burgundy text-sm" data-id="element-396">{testimonial.style}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}